export default function formCleaner(form) {
  const sections = form.sections;
  const result = { value: true };
  for (let section of sections) {
    const body = section.body;
    for (let part of body) {
      const question = part;
      // Check if label is present for every question
      if (!question.label) {
        return {
          value: false,
          message: "Please add the label for the question",
        };
      }
      if (question.showConditionally) {
        const conditionalQuestion = question.conditionalQuestion;
        if (!conditionalQuestion.key)
          return {
            value: false,
            message: `Please select the conditional question for the question ${question.label}`,
          };
        if (!conditionalQuestion.value || conditionalQuestion.value == "")
          return {
            value: false,
            message: `Please select the value for conditional question for the question ${question.label}`,
          };
      }
      switch (question.type) {
        case "line":
          for (const validator of question.validators) {
            if (validator.validator == "format") {
              // check for the availability of regex if format is regex
              if (validator.format == "regex" && validator.regex == null)
                return {
                  value: false,
                  message:
                    "Please add the regex for format validator in line input question",
                };

              if (
                (validator.format == "number-float" ||
                  validator.format == "number-int") &&
                validator.useLimit
              ) {
                // check for the availability of limit type
                if (!validator.limitType)
                  return {
                    value: false,
                    message:
                      "Please select the limit type for format validator in line input",
                  };

                // check for the availability of left and right
                if (validator.left == null || validator.right == null)
                  return {
                    value: false,
                    message:
                      "Please add the left and right limit for format validator in line input question",
                  };

                // check if the left limit is greater than right limit
                if (validator.left > validator.right)
                  return {
                    value: false,
                    message:
                      "Left limit should be less than right limit for format validator the line input question",
                  };
              }

              // check if the limit type is between and the left and right value are same
              if (
                validator.format == "number-float" &&
                validator.useLimit == true &&
                validator.limitType == "between" &&
                validator.right == validator.left
              )
                return {
                  value: false,
                  message:
                    "Left and right limits cannot be same for limit type between for format validator in line input question",
                };

              if (
                validator.format == "number-int" &&
                validator.useLimit == true
              ) {
                // check if the left and right limits are int
                if (validator.left % 1 != 0 || validator.right % 1 != 0)
                  return {
                    value: false,
                    message:
                      "Please add the integer value for left and right limit for format validator in line input question",
                  };

                // check if there are any available int between left and right
                if (
                  validator.limitType == "between" &&
                  validator.right - validator.left < 2
                )
                  return {
                    value: false,
                    message:
                      "There is no integer value between left and right limits in format validator in line input question",
                  };
              }
            }
            if (validator.validator == "length") {
              if (validator.min == null || validator.max == null)
                return {
                  value: false,
                  message:
                    "Please add the min and max length for length validator in line input question",
                };
              if (validator.min < 0 || validator.max < 0)
                return {
                  value: false,
                  message:
                    "Min and Max cannot be negative for length validator in line input question",
                };
              if (validator.min > validator.max)
                return {
                  value: false,
                  message:
                    "Min length should be less than max length for length validator the line input question",
                };
            }
          }
          question.properties = {
            placeholder: question.properties.placeholder ?? "",
          };
          break;
        case "paragraph":
          for (const validator of question.validators) {
            if (validator.validator == "format") {
              if (validator.format == "regex" && validator.regex == null)
                return {
                  value: false,
                  message:
                    "Please add the regex for format validator in paragraph input question",
                };
            }
            if (validator.validator == "length") {
              if (validator.min == null || validator.max == null)
                return {
                  value: false,
                  message:
                    "Please add the min and max length for length validator in paragraph input question",
                };
              if (validator.min < 0 || validator.max < 0)
                return {
                  value: false,
                  message:
                    "Min and max cannot be negative for length validator in paragraph input question",
                };
              if (validator.min > validator.max)
                return {
                  value: false,
                  message:
                    "Min length should be less than max length for length validator the paragraph input question",
                };
            }
          }
          question.properties = {
            placeholder: question.properties.placeholder ?? "",
          };
          break;
        case "rating":
          question.properties = {
            stars: question.properties.stars,
            lLabel: question.properties.lLabel,
            rLabel: question.properties.rLabel,
          };
          break;
        case "dropdown":
          if (question.properties.options) {
            for (const option of question.properties.options) {
              if (option.label == "" || option.value == "")
                return {
                  value: false,
                  message:
                    "Please add the label and value for the dropdown options",
                };
            }
            question.properties = {
              placeholder: question.properties.placeholder ?? "",
              options: question.properties.options.map((o) => {
                return {
                  label: o.label,
                  value: o.value,
                };
              }),
            };
          } else {
            return {
              value: false,
              message: "Please add the options for checkbox",
            };
          }
          break;
        case "radio":
          if (question.properties.options) {
            for (const option of question.properties.options) {
              if (option.label == "" || option.value == "")
                return {
                  value: false,
                  message:
                    "Please add the label and value for the dropdown options",
                };
            }
            question.properties = {
              options: question.properties.options.map((o) => {
                return {
                  label: o.label,
                  value: o.value,
                };
              }),
            };
          } else {
            return {
              value: false,
              message: "Please add the options for checkbox",
            };
          }
          break;
        case "checkbox":
          for (const validator of question.validators) {
            if (validator.validator == "tick") {
              if (validator.min == null || validator.max == null)
                return {
                  value: false,
                  message:
                    "Please add the min and max ticks for tick validator in checkbox input question",
                };
              if (validator.min < 0 || validator.max < 0)
                return {
                  value: false,
                  message:
                    "Min and max ticks cannot be negative for tick validator in checkbox input question",
                };
              if (validator.min > validator.max)
                return {
                  value: false,
                  message:
                    "Min ticks should be less than max ticks for tick validator the checkbox input question",
                };
            }
          }
          if (question.properties.options) {
            for (const option of question.properties.options) {
              if (option.label == "" || option.value == "")
                return {
                  value: false,
                  message:
                    "Please add the label and value for the checkbox options",
                };
            }
            question.properties = {
              options: question.properties.options.map((o) => {
                return {
                  label: o.label,
                  value: o.value,
                };
              }),
              otherOption: question.properties.otherOption,
            };
            break;
          } else {
            return {
              value: false,
              message: "Please add the options for checkbox",
            };
          }
        case "file":
          for (const validator of question.validators) {
            if (
              validator.validator == "fileType" &&
              validator.allowedTypes.length == 0
            )
              return {
                value: false,
                message:
                  "Please select the allowed types for file type validator in file input question",
              };
            if (validator.validator == "fileSize" && !validator.maxSize)
              return {
                value: false,
                message:
                  "Please select the maximum allowed size for file size validator in file input question",
              };
          }
          break;
        case "date": {
          for (const validator of question.validators) {
            if (validator.validator == "minDate" && !validator.value)
              return {
                value: false,
                message:
                  "Please select the date for minimum date validator in date input question",
              };
            if (validator.validator == "maxDate" && !validator.value)
              return {
                value: false,
                message:
                  "Please select the date for maximum date validator in date input question",
              };
          }
          const minDateValidatorIndex = question.validators.findIndex(
            (validator) => validator.validator == "minDate"
          );
          const maxDateValidatorIndex = question.validators.findIndex(
            (validator) => validator.validator == "maxDate"
          );
          if (
            minDateValidatorIndex != -1 &&
            maxDateValidatorIndex != -1 &&
            question.validators[minDateValidatorIndex].value >
              question.validators[maxDateValidatorIndex].value
          )
            return {
              value: false,
              message:
                "Minimum date must be less than maximum date in validators for date input question",
            };
          break;
        }
      }
    }
  }
  return result;
}
